import React, { useState, useEffect, useMemo, useRef } from 'react';
import cls from 'classnames';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import {
  getMaketsType,
  // getCalOtherList,
} from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/utilsTmp/countryUtils';
import { connect, getLocale } from 'umi';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { getItemFromArray } from '@/pages/intelligence/utils/tableUtils';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import useEarliestTime from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/utilsTmp/useEarliestTime';
import { getCountriesExtendParams } from '@intelligence/utils/filterUtils';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE, TopchartPageId } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import {
  DETAIL_PAGEID,
  getDetailPageCfg,
} from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/_config';
import CombineContent from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/components/StatsContext';
import { getDefaultPageSortAttr } from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/_utils';
import { getDeviceConfig } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
import useChartDownloadHooks from '@/pages/intelligence/pages/TopCharts/_hooks/useChartDownloadHooks';
import UserEngagementAmpereFilter from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/components/Sizer/UserEngagementAmpereFilter';
import { ampereMetricOptions } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/components/MetricsSelection/config';
import useGetCountriesEngagementData from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/UserEngagementAmpere/hooks/useGetCountriesEngagementData';
import { granularityDateMap } from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/UserEngagementAmpere/utils';
import { CONSOLE_AMPERE_PLATFORM_TEXT_MAP } from '@intelligence/pages/TopCharts/PCGames/_config/constant';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { pcconsoleStats } from '@intelligence/v3/constants/downloadLogPoint';

import './index.scss';

const UserEngagementAmpere = (props: any) => {
  const {
    isBasicLoading,
    loading,
    setLoading,
    topchartsState,
    tabType,
    pageId,
    basicInfo,
    gameId,
    appIds,
    regionsCountries,
    entityType,
    isTwoMonths,
    activeSegment,
    mainSegment,
    subSegment,
    gsdDevicesFlatten,
    gsdSegments,
    downloadModalSize = 820,
    filterLeftComp,
    getRadioOptionsTips,
  } = props;

  const { formatMessage, isEN } = useIntlExtend(); // 中英切换方法
  const locale = getLocale();

  const metricKey = activeSegment;
  const infoItem = getItemFromArray({
    list: ampereMetricOptions,
    key: 'value',
    keyVal: metricKey,
  });

  const hasDevice = entityType !== 'pc';

  const deviceDefVales = getDeviceConfig('ampereMau', entityType)?.value;
  const deviceOptions = getDeviceConfig('ampereMau', entityType)?.options;

  // 当前页面公共配置
  const pageCfg = getDetailPageCfg(DETAIL_PAGEID.ampere, tabType, entityType);

  const defaultByDeviceVal = pageCfg?.defaultByDeviceVal || undefined;

  const isStatsPage = tabType === 'stats';
  const isCountriesPage = tabType === 'countries';

  // 参数变化触发请求标识（避免请求返回的时间更新参数触发请求）
  const shouldFetchDataByFetchParamsChangeRef = useRef(true);

  // 当前指标对应的时间粒度
  const currentMetricDateType = granularityDateMap[infoItem?.dateEnum[0]] || 'month';

  const [fetchParams, setFetchParams] = useState({
    date_type: currentMetricDateType,
    start_date: '',
    end_date: '',
    data_sources: ['ampere'],
    region_type: 'market',
    regions: ['global'],
    markets: ['global'],
    entity_type: entityType,
    metric: [metricKey],
    unified_id: gameId,
    device: deviceDefVales,
  });

  // 是否有 device bar 使用状态指定，避免直接从 infoItem 变量中读取，避免 hasByDeviceBar 与 fetchParams 更新时机不一致导致多次触发请求
  const [hasByDeviceBar, setHasByDeviceBar] = useState(infoItem?.hasByDeviceBar);

  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } = useFilterExtend({});

  // 当前图表类型
  const [marketChartType, setMarketChartType] = useState<string>(ChartType.Bar);
  const isLineChart = ['line', 'stackedLine'].includes(marketChartType);

  const [regionOptions, setRegionOptions] = useState([]);
  const [filterLoading, setFilterLoading] = useState(true);

  // 获取计算总数的类型字段
  const [marketType, setMarketType] = useState(
    // getMaketsType(fetchParams.regions, fetchParams.regions),
    getMaketsType(fetchParams.markets, fetchParams.markets),
  );

  // 不展示堆叠折线图的指标使用 noStackedLineChart 属性控制隐藏
  const chartIconList = useMemo(() => {
    const validIconList = pageCfg?.chartIconList?.filter((item: any) =>
      infoItem?.noStackedLineChart ? item?.value !== 'stackedLine' : true,
    );

    // 如果切换指标后，指标无当前图表类型（如堆叠折线图），将图表类型重置为 柱图
    const isCurrentMarketChartTypeValid = validIconList?.find((item: any) => {
      return item?.value === marketChartType;
    });
    if (!isCurrentMarketChartTypeValid) {
      setMarketChartType(ChartType.Bar);
    }

    return validIconList;
  }, [infoItem, pageCfg, marketChartType]);

  const formatRegionParams = (markets: string[]) => {
    // 保存的方案选择后可特殊处理国家值为交集之后的值
    // @ts-ignore
    const { regionValues, filterExtendValue } = getCountriesExtendParams({
      regionOptions, // 国家筛选器 options,
      defalutMarket: ['global'], // 没取到交集用的默认值
      // Ampere 子段固有可选 'Global except China mainland'
      disableNoChina: false,
      markets,
      filterExtend: detailFilterExtend,
    });
    setDetailFilterExtend(filterExtendValue);
    return regionValues?.regions;
  };

  const { earliestPeriod, formattedEarliestDay, updateEarliestDateData, baseReleaseTimeValue, baseReleaseTimeData } =
    useEarliestTime({
      entityType,
      basicInfo,
      appIds,
      dateType: fetchParams.date_type,
      topchartsState,
    });

  const getExtendParams = () => {
    const newFetchParams: any = {};
    // 如果是月粒度就继承
    const timeExtend = detailFilterExtend[filterKeyMap.RANGE_TIME];
    const marketExtend = detailFilterExtend[filterKeyMap.REGION];
    if (timeExtend?.granularity === 'monthly') {
      // 如果是月粒度才继承
      newFetchParams.date_type = 'month';
      newFetchParams.start_date = timeExtend?.start_date || '';
      newFetchParams.end_date = timeExtend?.end_date || '';
    }
    if (timeExtend?.granularity === 'daily') {
      // 如果是日粒度才继承
      newFetchParams.date_type = 'date';
      newFetchParams.start_date = timeExtend?.start_date || '';
      newFetchParams.end_date = timeExtend?.end_date || '';
    }
    newFetchParams.region_type = 'market';
    const regions = formatRegionParams(marketExtend?.markets);
    newFetchParams.regions = regions;
    newFetchParams.markets = regions;
    return newFetchParams;
  };

  // 当前页面所需的数据状态及请求方法 hook 调用
  const {
    marketTableList,
    topDeviceBarData,
    topLineChartData,
    countriesChartDisplayCount,
    marketBarPieChartList,
    topList,
    marketLineLoading,
    countryLineLoading,
    setCountryLineLoading,
    marketLoading,
    marketError,
    getLineChartData,
    marketFixedTableData,
  } = useGetCountriesEngagementData({
    regionOptions,
    loading,
    fetchParams,
    setFetchParams,
    setLoading,
    shouldFetchDataByFetchParamsChangeRef,
    isTwoMonths,
    marketChartType,
    filterLoading,
    isBasicLoading,
    isOperateDetail,
    getExtendParams,
    updateEarliestDateData,
    hasByDeviceBar,
  });
  // 获取可视化下载配置 hooks
  const {
    chartDownloadConfig,
    // setSumList,
    showDropdownBtnListCur,
    // setTrendsChartDownList
  } = useChartDownloadHooks({
    locale,
    metricValue: activeSegment,
    entityType,
  });

  const prevMetricKeyRef = useRef<string>();

  useEffect(() => {
    const isMetricChanged =
      prevMetricKeyRef.current !== undefined && prevMetricKeyRef.current !== metricKey;
    prevMetricKeyRef.current = metricKey;

    if (isMetricChanged) {
      shouldFetchDataByFetchParamsChangeRef.current = true;
    }
    // 更新当前指标是否有分设备柱图展示状态
    setHasByDeviceBar(infoItem?.hasByDeviceBar);
    // 切换指标时重置图表类型
    setMarketChartType(ChartType.Bar);
    // 更新当前指标查询参数（值未变时不触发 state 更新，避免重复请求）
    setFetchParams((prev) => {
      if (prev.metric?.[0] === metricKey && prev.date_type === currentMetricDateType) {
        return prev;
      }
      return {
        ...prev,
        metric: [metricKey],
        date_type: currentMetricDateType,
      };
    });
  }, [metricKey, currentMetricDateType, infoItem?.hasByDeviceBar]);

  const handleConfirm = (value: any) => {
    let newFetchParams = { ...fetchParams, ...value };
    newFetchParams = { ...newFetchParams, metric: [metricKey] };
    // 修改筛选器，将需要根据数据变更发起的请求的标识置为 true
    shouldFetchDataByFetchParamsChangeRef.current = true;
    // 更新表单请求参数状态，触发请求
    setFetchParams(newFetchParams);
  };

  // 切换图表类型
  const changeMarketChartType = (value: string) => {
    setMarketChartType(value);

    // 从其他类型图表切换折线图之后才请求，折线图和堆叠折线图二者切换不需要请求
    if (['line', 'stackedLine'].includes(value) && !['line', 'stackedLine'].includes(marketChartType)) {
      // 获取折线图数据
      getLineChartData(fetchParams, true);
    }
  };
  const changeDeviceBtn = () => {
    // 获取设备数据 value
  };
  const getDownloadFetchParams = () => {
    let paramsTmp: { [key: string]: any } = {
      ...fetchParams,
      segment: pageId,
      unified_id: gameId,
      unified_ids: [gameId],
      currentMetric: ['revenue'].includes(mainSegment) ? subSegment : mainSegment,
      subSegment,
      // 固定传 market
      region_type: 'market',
      // regionType: "region",
      // regions: ['global'],
      isCountriesPage,
    };

    if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
      paramsTmp = {
        ...paramsTmp,
        source: paramsTmp?.data_sources?.[0] || '',
        sort_field: paramsTmp?.metric?.[0] || '',
      };
    }

    return paramsTmp;
  };

  const onFilterInit = (params: any) => {
    const { loading, regionOptions } = params || {};
    setFilterLoading(loading);
    setRegionOptions(regionOptions);
  };

  const getCardStatus = () => {
    return {
      isError: marketError,
      isLoading: loading || marketLoading,
      isNoData: !marketTableList?.length && !marketFixedTableData?.length,
    };
  };

  const segmentTitle = formatMessage({ id: infoItem?.text });

  const pageSortAttr = getDefaultPageSortAttr(isStatsPage, 'desc', metricKey);

  const ifUseMarketLineLoading = useMemo(() => {
    let ifUseTemp = false;
    if (isCountriesPage && (marketChartType === 'line' || marketChartType === 'stackedLine')) {
      ifUseTemp = true;
    }
    return ifUseTemp;
  }, [isCountriesPage, marketChartType]);

  return (
    <div
      className={cls('dbi-countries-user-engagement-ampere-container', {
        // 'dbi-ampere-line-chart': isLineChart,
      })}
    >
      <div className="dbi-statsfilter-warp">
        <div className="statsfilter-warp-left">
          {/* Metrics 下拉选择器 */}
          {filterLeftComp}

          {/* 其余筛选项 */}
          <UserEngagementAmpereFilter
            onFilterInit={onFilterInit}
            timeFilterValues={{
              type: fetchParams.date_type,
              value: [fetchParams.start_date, fetchParams.end_date],
            }}
            filterConfirm={handleConfirm}
            filterReset={() => {}}
            globalOnly={infoItem?.globalOnly}
            entityType={entityType}
            basicInfo={basicInfo}
            appIds={appIds}
            sinceReleaseTime={baseReleaseTimeValue}
            earliestDataTime={earliestPeriod}
            hasDevice={hasDevice}
            deviceDefVales={deviceDefVales as string[]}
            deviceOptions={deviceOptions}
            currentMetricDateType={currentMetricDateType}
            getRadioOptionsTips={getRadioOptionsTips}
          />
          {infoItem?.globalOnly && (
            <span className="dbi-statsfilter-warp-left-text">{formatMessage({ id: 'dbi_global_only' })}</span>
          )}
        </div>
        <div className="dbi-statsfilter-warp-right">
          <ExportTable
            entityType={entityType}
            tableParams={getDownloadFetchParams()}
            businessType={`${entityType}-stats-countries-ampere`}
            isDisableDownload={loading}
            isShowMaxDownloadRowsTips={false}
            downloadModalSize={downloadModalSize}
            isDisableDataAmount={true}
            newStyleFileName={`${basicInfo?.name}${isCountriesPage ? '_Countries' : ''}`}
            pageId={entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE ? TopchartPageId.PCConsoleMetricsTable : undefined}
            gsdDevicesFlatten={gsdDevicesFlatten}
            gsdSegments={gsdSegments}
            showDropdownBtnList={false}
            chartDownloadConfig={chartDownloadConfig}
            tabType={tabType}
            downloadLogConfigKey={pcconsoleStats?.[`${entityType}_${tabType}_${mainSegment}`]}
          />
        </div>
      </div>
      <CombineContent
        pageId={pageId}
        entityType={entityType}
        isCountriesPage={isCountriesPage}
        fixedTableData={marketFixedTableData}
        sumAvgMaxList={[]}
        tableData={marketTableList}
        barData={marketBarPieChartList}
        pieData={marketBarPieChartList}
        lineData={topLineChartData}
        chartType={marketChartType}
        stackBarData={topDeviceBarData}
        // calOtherList={getCalOtherList(marketType, topList)}
        setChartType={changeMarketChartType}
        metricSegVal={subSegment}
        setMetricSegVal={() => {}}
        cardStatus={getCardStatus()}
        earliestDay={formattedEarliestDay}
        baseReleaseTime={baseReleaseTimeData}
        firstWeekReleaseTime={baseReleaseTimeValue}
        earliestPeriod={earliestPeriod}
        defaultByDeviceVal={defaultByDeviceVal}
        dateType={fetchParams.date_type}
        startDate={fetchParams?.start_date}
        endDate={fetchParams?.end_date}
        pageSortAttr={pageSortAttr}
        sourceList={fetchParams.device?.map((item) => CONSOLE_AMPERE_PLATFORM_TEXT_MAP[item] || item)}
        pageCfg={{
          ...pageCfg,
          disableChartType: infoItem?.globalOnly ? [ChartType.Pie] : [],
          tableMetricList: [infoItem],
          chartIconList,
          defaultChartType: ChartType.Bar,
        }}
        cardTitle={
          isEN
            ? `${formatMessage({
                id: `dbi_detail_user_engagement_ampere`,
              })}${segmentTitle}`
            : `${segmentTitle}${formatMessage({
                id: `dbi_detail_user_engagement_ampere`,
              })}`
        }
        subTitle={''}
        chartLoading={countryLineLoading}
        setChartLoading={setCountryLineLoading}
        marketLineLoading={marketLineLoading}
        ifUseMarketLineLoading={ifUseMarketLineLoading}
        visualisMetric={metricKey}
        visualisTitleNow={formatMessage({ id: infoItem?.text })}
        gameName={basicInfo?.name}
        gameCover={basicInfo?.cover}
        changeDeviceBtn={changeDeviceBtn}
        regionsCountries={regionsCountries || []}
        isPercentage={infoItem?.renderType === RenderType.GROWTH_ONLY}
        //  百分比指标指定 Y 轴最大值为 100%
        yAxisConfig={infoItem?.renderType === RenderType.GROWTH_ONLY ? { max: 100, interval: 25 } : {}}
        // ampere 百分比值为小数，处理时需 * 100 (不需要了,这个是百分比堆叠折线图显示问题处理，可能影响普通柱图，百分比不显示堆叠折线图了)
        // isPercentageDecimal={infoItem?.renderType === RenderType.GROWTH_ONLY}
        mainSegment={mainSegment}
        ifLineChartLegendOn={showDropdownBtnListCur}
        stackLineTooltipShowAll={marketChartType === 'stackedLine'}
        // 显示数量 20 (Top20) + 1 (Others)
        showChartsItemNum={countriesChartDisplayCount}
        tooltip={
          // isLineChart
          //   ? {
          //       // Tooltip 内容超出时出现滚动条并允许鼠标移入
          //       // 鼠标可以移入 tooltip
          //       enterable: true,
          //       // 设置滚动样式，调整 max-height 以控制高度
          //       extraCssText: 'padding: 6px; background: #262832;',
          //     }
          //   :
          {
            appendToBody: true,
          }
        }
      />
    </div>
  );
};

export default connect((state: any) => ({
  filterState: state[FILTER_EXTEND_NAMESPACE],
  topchartsState: state[DBI_TOPCHARTS],
}))(UserEngagementAmpere);
